import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";

import {
  OverlayTrigger,
  InputGroup,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

export class AccountPayables extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      accountpayables: [],
      accountpayablesFiltered: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
      selectedStatus: "1",
    };
  }
  GetAccountPayables = () => {
    fetch(
      process.env.REACT_APP_API +
        "Account/GetAccountPayables/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ accountpayables: data }, () => {
            this.setState({
              accountpayablesFiltered: this.state.accountpayables.filter(
                (f) => f.status == 1
              ),
            });
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnSaved = () => {
    this.OnRefreshButtonClick();
  };
  OnDeleted = () => {
    this.OnRefreshButtonClick();
  };

  OnRefreshButtonClick = () => {
    this.setState({ selectedStatus: "1" });
    this.setState({ accountpayables: [] }, () => {
      this.GetAccountPayables();
    });
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };

  OnUpdated = (indexno) => {
    this.OnRefreshButtonClick();
  };

  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
    this.OnRefreshButtonClick();
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.state.accountpayables.length == 0) this.GetAccountPayables();
  };

  render() {
    return (
      <>
        <div className="Container-fluid p-0 ">
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
            <h3>
              {" "}
              <b>Account Payables</b> &nbsp;
            </h3>
            <Navbar.Collapse className="justify-content-end mx-0 ">
              <Nav>
                <ButtonToolbar className="text-end align-middle">
                  <Button
                    className="mainthemecolor"
                    // onClick={() => this.handleAddAccountPayable()}
                    onClick={() => this.setState({ addModalShow: true })}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      fill="currentColor"
                      class="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    Add
                  </Button>
                  &nbsp;
                  <Button
                    className="mainthemecolor"
                    size=""
                    onClick={() => this.OnRefreshButtonClick()}
                  >
                    <BiRefresh size="26"></BiRefresh>
                    Refresh
                  </Button>
                  &nbsp;
                  {this.state.addModalShow === true ? (
                    <AccountPayableAddOrEditModal
                      show={this.state.addModalShow}
                      Type="Add"
                      onHide={this.addModalClose}
                    />
                  ) : null}
                </ButtonToolbar>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <div className="purposestyle p-2 ">
            {" "}
            <b>Purpose:</b> Use this module to capture all Payable Transaction
            from Business account to 3rd party or to other businesses. This is a
            Tracking module to keep track of all transaction amount that need to
            Paid fro Business Account. Ex: Transaction could be Paying Loan,
            Purchases, etc.,
          </div>
          <div className="bg-light ">
            <Table className="bg-light m-0 p-0">
              <tr className="border-0">
                <td width="20%">
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">Status</InputGroup.Text>
                    <Form.Select
                      value={this.state.selectedStatus}
                      onChange={(e) => {
                        this.setState({ selectedStatus: e.target.value });
                        if (e.target.value == "") {
                          this.setState({
                            accountpayablesFiltered: this.state.accountpayables,
                          });
                        } else {
                          this.setState(
                            {
                              accountpayablesFiltered: [],
                            },
                            () => {
                              this.setState({
                                accountpayablesFiltered:
                                  this.state.accountpayables.filter(
                                    (f) => f.status == e.target.value
                                  ),
                              });
                            }
                          );
                        }
                      }}
                    >
                      <option value=""></option>
                      <option value="1">Yet to Pay</option>
                      <option value="2">Paid</option>
                    </Form.Select>
                  </InputGroup>
                </td>
              </tr>
            </Table>
          </div>
          <div>
            <Table border striped className="px-0 bg-white ">
              <thead className="">
                <tr className="text-start text-black bg-white border">
                  <th width="5%">#</th>
                  <>
                    <th width="10%">Created</th>
                    <th width="20%">Payable To</th>
                    <th width="30%">Details</th>
                    <th width="10%">Amount</th>
                    <th width="10%">CreatedBy</th>
                    <th width="10%">Status</th>
                    <th width="10%" className="text-end">
                      Options
                    </th>
                  </>
                </tr>
              </thead>
              <tbody className="text-primary border">
                {this.state.accountpayablesFiltered
                  .sort((a, b) => (a.created > b.created ? 1 : -1))
                  .map((accountpayable, i) =>
                    this.state.reload === true ? (
                      <EditAccountPayableInline
                        index={i}
                        accountpayable={accountpayable}
                        OnDeleted={this.OnDeleted}
                      ></EditAccountPayableInline>
                    ) : null
                  )}
              </tbody>
            </Table>
          </div>
        </div>
      </>
    );
  }
}

export class EditAccountPayableInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      accountpayable: "",
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      editModalShow: false,
    };
  }

  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnDelete = () => {
    if (this.state.accountpayable.id == undefined) {
      this.ShowMessagBox(
        "Information",
        "This is invalid row which can't be deleted. Press Refresh!"
      );
      return;
    }

    this.ShowLoadSpinner();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "Account/DeleteAccountPayable/" +
        this.state.accountpayable.id,
      requestOptions
    )
      .then((res) => {
        if (res.status != 200) {
          this.HideLoadSpinner();
          alert(
            "Not deleted. This AccountPayable may be associated with few Products. First disassociate this accountpayable from the Products and then try!"
          );
          return;
        }
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Status",
          "Deleted Successfully. Click Refresh Button to see the changes!"
        );
        this.props.OnDeleted();
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("OnDelete Failed" + error);
      });
  };

  componentDidMount = () => {
    this.setState({
      accountpayable: this.props.accountpayable,
    });
  };
  OnEditButtonClick = () => {
    this.setState({ editModalShow: true }, () => {});
  };

  editModalClose = () => {
    this.setState({ editModalShow: false }, () => {});
  };

  render() {
    return (
      <>
        {this.state.editModalShow === true ? (
          <AccountPayableAddOrEditModal
            show={this.state.editModalShow}
            onHide={this.editModalClose}
            accountpayable={this.state.accountpayable}
            Type="Edit"
          />
        ) : (
          ""
        )}
        {this.state.loadSpinnerOpen === true ? (
          <LoadSpinner open="true"></LoadSpinner>
        ) : (
          ""
        )}
        <tr
          className="text-center align-middle text-secondary bg-white mx-5"
          style={{ fontSize: "12px" }}
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <td className="text-start ">{this.props.index + 1}</td>
          <td className="text-start ">
            {this.context.GetInDateFormat(
              new Date(this.state.accountpayable.created)
            )}
          </td>
          <td className="text-start ">{this.state.accountpayable.details}</td>
          <td className="text-start ">{this.state.accountpayable.payTo}</td>
          <td className="text-start ">{this.state.accountpayable.amount}</td>
          <td className="text-start ">{this.state.accountpayable.createdBy}</td>
          <td className="text-start ">
            {this.state.accountpayable.status == 1 ? "Yet to Pay" : "Paid"}
          </td>

          <td className="col-md-2 text-end align-middle ">
            <div class="btn-group">
              <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                <Button
                  variant="warning"
                  onClick={(e) => {
                    this.OnEditButtonClick(e);
                  }}
                >
                  <BsFillPencilFill size="20" />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                overlay={
                  <Tooltip>Warning! This will delete related records.</Tooltip>
                }
              >
                <Button
                  className="mx-1 "
                  variant="danger"
                  onClick={(e) => {
                    if (
                      window.confirm(
                        "Warning! Are you sure you want to Delete?"
                      )
                    ) {
                      this.OnDelete(e);
                    }
                  }}
                >
                  X
                </Button>
              </OverlayTrigger>
            </div>
          </td>
        </tr>
      </>
    );
  }
}

export class AccountPayableAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      accountpayable: {
        accountpayableName: "",
        manufacturerName: "",
        imgFileName: "",
        hideMe: false,
      },
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
    };
  }

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide();
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  AddOrUpdateAccountPayableInDB = () => {
    this.ShowLoadSpinner();

    var tmpAccountPayable = this.state.accountpayable;
    if (this.props.Type == "Edit") {
      tmpAccountPayable = this.props.accountpayable;
    } else {
      tmpAccountPayable.storeId = this.context.storeId;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmpAccountPayable),
    };

    fetch(
      process.env.REACT_APP_API + "Account/AddOrUpdateAccountPayable/",
      requestOptions
    )
      .then((res) => {
        if (res.status == 200) {
          this.HideLoadSpinner();
          if (tmpAccountPayable.status == 2)
            // paid
            alert(
              "Updated Successfully with Information!  Please make sure to add an entry in Expenses/Debits module for accounting purpose!"
            );
          this.props.onHide();
          return;
        }
        this.HideLoadSpinner();
        alert("This AccountPayable is already exist. try again!");
        return;
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Exception. Received an Exception. Try after sometime !" + error);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.AddOrUpdateAccountPayableInDB();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "details":
        this.state.accountpayable.details = value;
        break;
      case "payTo":
        this.state.accountpayable.payTo = value;
        break;
      case "amount":
        this.state.accountpayable.amount = value;
        break;
      case "createdBy":
        this.state.accountpayable.createdBy = value;
        break;
      case "status":
        this.state.accountpayable.status = value;
        break;
    }
    this.setState({
      accountpayable: this.state.accountpayable,
    });
  };

  componentDidMount() {
    if (this.props.Type == "Edit") {
      this.setState({
        accountpayable: this.props.accountpayable,
      });
    }
  }

  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="AccountPayableModal"
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type == "Edit"
                  ? "Edit Account Payable"
                  : "Add Account Payable"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row
                className="m-2 p-2 bg-light border"
                style={{ fontSize: "12pt" }}
              >
                <Col md={12}>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Payable To
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="payTo"
                        value={this.state.accountpayable.payTo}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Payable Details
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="details"
                        value={this.state.accountpayable.details}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Amount
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="number"
                        name="amount"
                        value={this.state.accountpayable.amount}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Created by
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="createdBy"
                        value={this.state.accountpayable.createdBy}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Status
                    </Form.Label>
                    <Col sm="9">
                      <Form.Select
                        type="text"
                        name="status"
                        value={this.state.accountpayable.status}
                        placeholder=""
                        required
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value=""></option>
                        <option value="1">Yet to Pay</option>
                        <option value="2">Paid</option>
                      </Form.Select>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}
